<div class="app-breadcrumb">
  <p-breadcrumb
    [styleClass]="styleClass"
    [model]="items"
    [home]="home"
  ></p-breadcrumb>
</div>
